
import {PriceTypeEnum} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Options";
import {StoreAutoIncrement, StoreBase, StoreDataType} from "shared/core/Store/StoreBase";


export class AdditionalOptionValue extends StoreBase{
    Id:number;
    Value:string;

    protected LoadDefaultValues() {
        this.Id=0;
        this.Value='';
    }
}
export class OptionItem extends StoreBase{

    public Label:string;
    public RegularPrice:string;
    public SalePrice:string;
    public PriceType:PriceTypeEnum;
    public Id:number;
    public Selected:boolean;
    public URL:string;
    @StoreDataType(AdditionalOptionValue)
    public AdditionalOptionValue:AdditionalOptionValue[];

    protected LoadDefaultValues() {
        this.Selected=false;
        this.Id=0;
        this.Label='';
        this.RegularPrice='';
        this.SalePrice='';
        this.PriceType=PriceTypeEnum.fixed_amount;
        this.URL='';
        this.AdditionalOptionValue=[];
    }


}



export class AdditionalOptionColumn  extends StoreBase{
    @StoreAutoIncrement('AdditionalOptionColumn')
    public Id:number;
    public Label:string;


    protected LoadDefaultValues() {
        this.Id=0;
        this.Label='';

    }
}